module.exports = __webpack_public_path__ + "static/media/slmd.8201128b.png";